import { render, staticRenderFns } from "./dashboard-sale-instant-table.vue?vue&type=template&id=5322f9fe&scoped=true&"
import script from "./dashboard-sale-instant-table.vue?vue&type=script&lang=js&"
export * from "./dashboard-sale-instant-table.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-sale-instant-table.vue?vue&type=style&index=0&id=5322f9fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5322f9fe",
  null
  
)

export default component.exports